// extracted by mini-css-extract-plugin
export default {"breadCrumbContainer":"@gscope-mfe-common-components__src-components-BreadCrumbs-___BreadCrumbs-module__breadCrumbContainer___k6TEi"};